import React from "react";
import { withTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
import { URLAllowListInput, KeyValueTable } from "components/common";
import ObjectUtils from "util/ObjectUtils";
class HTTPJSONPathAdapterFieldSet extends React.Component {
  constructor() {
    super(...arguments);
    this.onHTTPHeaderUpdate = (headers) => {
      const { config, updateConfig } = this.props;
      const configChange = ObjectUtils.clone(config);
      configChange.headers = headers;
      updateConfig(configChange);
    };
  }
  render() {
    const { config, handleFormEvent, validationMessage, validationState, t } = this.props;
    return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
      URLAllowListInput,
      {
        label: t("http_doc.lookup_url_label"),
        onChange: handleFormEvent,
        validationMessage: validationMessage("url", t("http_fields.url_validation")),
        validationState: validationState("url"),
        url: config.url,
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9",
        urlType: "regex"
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "text",
        id: "single_value_jsonpath",
        name: "single_value_jsonpath",
        label: t("http_doc.single_value_label"),
        required: true,
        onChange: handleFormEvent,
        help: validationMessage("single_value_jsonpath", t("http_fields.single_value_help")),
        bsStyle: validationState("single_value_jsonpath"),
        value: config.single_value_jsonpath,
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9"
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "text",
        id: "multi_value_jsonpath",
        name: "multi_value_jsonpath",
        label: t("http_doc.multi_value_label"),
        onChange: handleFormEvent,
        help: validationMessage("multi_value_jsonpath", t("http_fields.multi_value_help")),
        bsStyle: validationState("multi_value_jsonpath"),
        value: config.multi_value_jsonpath,
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9"
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "text",
        id: "user_agent",
        name: "user_agent",
        label: t("http_doc.http_useragent_label"),
        required: true,
        onChange: handleFormEvent,
        help: t("http_fields.user_agent_help"),
        value: config.user_agent,
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9"
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "http_headers",
        label: t("http_fields.headers_label"),
        help: t("http_fields.headers_help"),
        labelClassName: "col-sm-3",
        wrapperClassName: "col-sm-9"
      },
      /* @__PURE__ */ React.createElement(KeyValueTable, { pairs: config.headers || {}, editable: true, onChange: this.onHTTPHeaderUpdate })
    ));
  }
}
export default withTranslation("lookup_tables")(HTTPJSONPathAdapterFieldSet);
